import React from 'react';
import { connect } from 'react-redux';
import Remarkable from 'react-remarkable';
import {
  isJSON,
  getFromDico,
  formatNumber,
  getFromDicoFullRef,
} from '../../../Utils/Utils';
import ObjGraphsRadar from '../ObjGraphsRadar/ObjGraphsRadar';
import ObjectActionCreators from '../../../../actions';
import ObjGraphsBarHtml from '../ObjGraphsBar/ObjGraphsBarHtml';
import ObjGraphsBarHtml2D from '../ObjGraphsBar/ObjGraphsBarHtml2D';
import ObjGraphsBubbleHtml from '../ObjGraphsBubbleHtml/ObjGraphsBubbleHtml';
import {
  MarkDownBloc,
  ObjFieldFormulaContent,
  ObjFieldsStyles,
  RichContent,
} from './ObjFieldsCSS';
import {
  refreshAISynthesis,
  cleanAISynthesis,
} from '../../../../reducers/objectReducers/action';

class ObjFieldFormula extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      localInstruction: '',
    };
    this.handleRefreshFormula = this.handleRefreshFormula.bind(this);
    this.handleCleanFormula = this.handleCleanFormula.bind(this);
    this.handleChangeLocalInstruction =
      this.handleChangeLocalInstruction.bind(this);
  }

  handleRefreshFormula() {
    this.props.refreshAISynthesis(
      this.props.objId,
      this.props.attrName,
      this.state.localInstruction
    );
  }

  handleCleanFormula() {
    this.props.cleanAISynthesis(this.props.objId, this.props.attrName);
  }

  handleChangeLocalInstruction(e) {
    this.setState({ localInstruction: e.target.value });
  }

  stopAll = (e) => {
    // capture + bubble shield
    e.stopPropagation();
    if (e.nativeEvent?.stopImmediatePropagation) {
      e.nativeEvent.stopImmediatePropagation();
    }
  };

  GraphGuard = ({ children }) => (
    <div
      data-stop-parent="1"
      role="group"
      tabIndex={-1}
      style={{
        width: '100%',
        border: '0px solid var(--ds-border-intense)',
        cursor: 'default',
        borderRadius: '4px',
        backgroundColor: 'var(--ds-bg-base)',
        padding: '5px',
      }}
    >
      {children}
    </div>
  );

  render() {
    const formulaCat1 = this.props.formulaCat1;
    const formulaCat2 = this.props.formulaCat2;
    const formulaType = this.props.formulaType;
    const formulaObject = this.props.formulaObject;
    const refValue = this.props.refValue;
    const unit = this.props.unit;
    const mini = this.props.mini;
    const type = this.props.type;
    const attrName = this.props.attrName;
    const optionsCat1 = this.props.optionsCat1;
    const optionsCat2 = this.props.optionsCat2;
    const objId = this.props.objId;
    const { GraphGuard } = this;

    if (isJSON(this.props.value) && this.props.value.startsWith('[')) {
      const myArray = JSON.parse(this.props.value);

      if (myArray != null && myArray.length > 0) {
        myArray.forEach((element) => {
          Object.keys(element).forEach((key) => {
            if (element[key].startsWith('empl')) {
            } else if (key !== 'result') {
            }
          });
        });

        let isRadar = this.props.options === 'radar';
        const isBubble = this.props.options === 'bubble';

        if (isJSON(this.props.options)) {
          try {
            const objJSON = JSON.parse(this.props.options);
            if (objJSON != null && objJSON.type != null) {
              isRadar = objJSON.type === 'radar';
            }
          } catch (e) {
            console.log(e);
          }
        }
        const isDark = this.props.pal.isDark;
        return (
          <ObjFieldFormulaContent
            $color={isDark ? 'white' : '#999999'}
            $backgroundColor={
              mini ? 'var(--ds-bg-secondary)' : 'var(--ds-bg-base)'
            }
          >
            {mini && (
              <div
                style={{
                  fontSize: 11,
                  fontWeight: '900',
                  backgroundColor: 'var(--ds-bg-secondary)',
                  padding: '3px',
                  color: 'var(--ds-base)',
                  borderTopRightRadius: '0px',
                  borderTopLeftRadius: '5px',
                  borderBottomRightRadius: '0px',
                  borderBottomLeftRadius: '5px',
                  marginLeft: '-3px',
                  height: '20px',
                  marginTop: '0px',
                  marginBottom: '6px',
                  padding: '5px',
                  paddingLeft: '8px',
                  border: '1px lsid red',
                }}
              >
                {this.props.label}
              </div>
            )}
            {isRadar && (
              <GraphGuard>
                <ObjGraphsRadar
                  objId={objId}
                  mini={this.props.mini}
                  data={myArray}
                  pal={this.props.pal}
                  formulaCat1={formulaCat1}
                  formulaCat2={formulaCat2}
                  options={this.props.options}
                  optionsCat1={optionsCat1}
                  optionsCat2={optionsCat2}
                />
              </GraphGuard>
            )}
            {!isRadar && !isBubble && !formulaCat2 && (
              <GraphGuard>
                <ObjGraphsBarHtml
                  objId={objId}
                  formulaCat1={formulaCat1}
                  options={this.props.options}
                  optionsCat1={this.props.optionsCat1}
                  mini={this.props.mini}
                  data={myArray}
                  pal={this.props.pal}
                />
              </GraphGuard>
            )}
            {!isRadar && !isBubble && formulaCat2 && (
              <GraphGuard>
                <ObjGraphsBarHtml2D
                  objId={objId}
                  formulaCat1={formulaCat1}
                  formulaCat2={formulaCat2}
                  options={this.props.options}
                  mini={this.props.mini}
                  data={myArray}
                />
              </GraphGuard>
            )}
            {isBubble && (
              <GraphGuard>
                <ObjGraphsBubbleHtml
                  objId={objId}
                  formulaCat1={formulaCat1}
                  formulaCat2={formulaCat2}
                  options={this.props.options}
                  optionsCat1={optionsCat1}
                  optionsCat2={optionsCat2}
                  refValue={refValue}
                  mini={this.props.mini}
                  data={myArray}
                  pal={this.props.pal}
                  displayTotalsX={!mini}
                  displayTotalsY={!mini}
                />
              </GraphGuard>
            )}
          </ObjFieldFormulaContent>
        );
      }
      return <></>;
    }

    return (
      <>
        {formulaType !== 'AISynthesis' && (
          <div style={ObjFieldsStyles.value}>
            {formatNumber(this.props.value)}
            {unit}
          </div>
        )}
        {formulaType === 'AISynthesis' && (
          <GraphGuard>
            <div style={{ display: 'flex', gap: '5px' }}>
              <button
                style={{
                  backgroundColor: 'var(--ds-bg-base)',
                  color: 'var(--ds-text-base)',
                  border: '1px solid var(--ds-border-base)',
                  borderRadius: '3px',
                }}
                onClick={this.handleRefreshFormula}
              >
                Refresh
              </button>
              <button
                style={{
                  backgroundColor: 'var(--ds-bg-base)',
                  color: 'var(--ds-text-base)',
                  border: '1px solid var(--ds-border-base)',
                  borderRadius: '3px',
                }}
                onClick={this.handleCleanFormula}
              >
                Clean
              </button>
              <input
                placeholder="Alternative Instructions"
                style={{ flex: '1' }}
                onChange={this.handleChangeLocalInstruction}
                value={this.state.localInstruction}
              />
            </div>

            <MarkDownBloc>
              <Remarkable source={this.props.value ?? ''} />
            </MarkDownBloc>
          </GraphGuard>
        )}
      </>
    );
  }
}
ObjFieldFormula.defaultProps = {
  mini: false,
};

//------------------------------------------------------------------------------------------------------
const mapDispatchToProps = (dispatch) => {
  return {
    refreshAISynthesis: (objId, attrName, localInstruction) =>
      dispatch(refreshAISynthesis(objId, attrName, localInstruction)),
    cleanAISynthesis: (objId, attrName) =>
      dispatch(cleanAISynthesis(objId, attrName)),
  };
};

export default connect(null, mapDispatchToProps)(ObjFieldFormula);
